import Image from 'next/image';

import { cn } from '@/lib/utils';
import XIcon from '../Icons/X';
import { buttonVariants } from '../Button';
import { AnimatedLink } from '../AnimatedLink';

type Props = {
  imageSrc: string;
  title: string;
  description: string;
  url: string | null;
  journalName: string;
  handleClose: () => void;
  readArticleLabel: string;
};

export default function VillageArticlesSectionCarouselDialog({
  imageSrc,
  handleClose,
  ...infos
}: Props) {
  return (
    <>
      <div
        onClick={handleClose}
        className="z-[999] fixed left-0 top-0 w-full h-full bg-black/60 overflow-hidden">
        <div
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          className="max-w-full w-full mt-0 relative mx-auto mb-[50px] bg-white shadow-[0_1px_3px_rgba(0,0,0,.3)] md:mt-[15vh] md:w-3/4 md:max-w-[37.5rem] desktop:max-w-[66.875rem] opacity-100">
          <div className="h-[100px] bg-gray-100 flex items-center m-0 p-0">
            <span>
              <Image
                src={imageSrc}
                alt={infos.journalName}
                fill
                className="!relative !object-contain ml-5 md:ml-[60px] !w-auto !h-[40px] inline-block align-middle max-w-full"
                sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
                style={{
                  objectFit: 'cover',
                }}
              />
            </span>
            <button
              onClick={handleClose}
              type="button"
              className="flex items-center justify-center appearance-none absolute top-[10px] right-[10px] z-10 rounded-full w-10 h-[40px] leading-[40px] text-gray-500 text-center bg-white cursor-pointer shadow-default desktop:top-[-10px] desktop:right-[-10px]">
              <XIcon className="w-6 h-6 fill-current" />
            </button>
          </div>

          <div className="text-base text-graphite bg-white break-normal py-[30px] px-[40px]">
            <div>
              <span className="text-4xl font-semibold mb-[30px] inline-block">
                {infos.title}
              </span>
              <p className="mb-4 leading-[1.6]">{infos.description}</p>
            </div>
            {infos.url && (
              <div className="">
                <a
                  className={cn(
                    buttonVariants({ variant: 'default', size: 'default' }),
                    'w-fit z-10 py-[20px] px-[40px] mt-[30px] desktop:hidden',
                  )}
                  href={infos.url}
                  target="_blank">
                  {infos.readArticleLabel}
                </a>
              </div>
            )}
            {infos.url && (
              <div>
                <AnimatedLink
                  href={infos.url}
                  className="w-fit hidden desktop:block py-[20px] px-[10px] mt-[30px] desktop:px-[40px] desktop:w-fit"
                  target="_blank">
                  {infos.readArticleLabel}
                </AnimatedLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
